import React from "react"
import "./Authenticate.css"
import SideNav from "../layout/SideNav"
import Card from "../core/Card"
import LoginPage from "./LoginPage"
import Logo from "../core/components/Logo"
import {
  Col,
  Checkbox,
  Button as AButton,
  Switch,
  DatePicker,
  Select,
  Modal,
  Input,
  Icon as AIcon,
  Tooltip,
  Form,
  Alert,
  Popconfirm,
  Row,
  Progress
} from "antd"
import {
  Icon,
  BackIcon,
  BriefcaseIcon,
  CarIcon,
  DotIcon,
  ForwardIcon
} from "../core/icons"
import { Field, reduxForm, submit } from "redux-form"
import makeField from "../account/makeField"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import Line from "../core/Line"
import { login } from "./actions"
import styled from "styled-components"
import TextAppLink from "../home/TextAppLink"
import { push } from "react-router-redux"
import AnalyticsHelper from "../utils/AnalyticsHelper"
import CloudEvent from "../utils/CloudEvent"
// LOCAL IMPORTS:

import {
  BusinessLine,
  CustomLine
} from "../account/business-lines/BusinessLines"
import { save, addCustom, toggle } from "../account/business-lines/actions"
import {
  Button,
  Steps,
  StepContainer,
  StepCard,
  TitleRow,
  Content,
  StepProgress
} from "./steps/index"
import WorkStatus from "./StepOne"
// COMPONENTS:

const BusinessLines = ({
  error,
  customLine,
  active,
  available,
  toggle,
  dispatch,
  save,
  addCustom,
  showCustomField,
  submitting,
  onRemoteSubmit,
  submitCustomLine,
  onCustomChange
}) => (
  <div className="BusinessLines">
    {showCustomField && (
      <CustomLine selected name={"custom"}>
        <Button
          style={{ float: "right", marginTop: "2px", marginLeft: "12px" }}
          onClick={submitCustomLine}
          type="primary"
        >
          Add
        </Button>

        <Field
          name="customLine"
          type="text"
          component={"input"}
          placeholder="Enter business line / company name..."
          onChange={onCustomChange}
        />
      </CustomLine>
    )}
    {error && <strong>{error}</strong>}

    {available.map((line, i) => (
      <BusinessLine
        key={i}
        name={line}
        selected={active.includes(line)}
        toggle={toggle}
      >
        {line}
      </BusinessLine>
    ))}
  </div>
)

const CardHolder = styled.div`
  display: flex;
`

const BusinessLinesStep = props => (
  <StepContainer>
    <div>
      <StepCard>
        <StepProgress step={2} />
      </StepCard>

      <StepCard>
        <TitleRow>
          <h3>What do you do for work?</h3>
          <Button
            primary
            loading={props.submitting}
            onClick={props.onRemoteSubmit}
          >
            Continue
          </Button>
        </TitleRow>

        <Content>
          <Row>
            <Button
              link
              pullRight
              onClick={props.addCustom}
              disabled={props.showCustomField}
            >
              <AIcon type="plus" />Add Custom
            </Button>
          </Row>

          <Row>
            <BusinessLines {...props} />
          </Row>
        </Content>
      </StepCard>
    </div>
  </StepContainer>
)

const BusinessLinesStepWithStackingDemo = props => (
  <CardHolder>
    <WorkStatus swiped />
    <StepContainer>
      <div>
        <StepCard>
          <StepProgress step={2} />
        </StepCard>

        <StepCard>
          <TitleRow>
            <h3>What do you do for work?</h3>
            <Button
              primary
              loading={props.submitting}
              onClick={props.onRemoteSubmit}
            >
              Continue
            </Button>
          </TitleRow>

          <Button
            link
            pullRight
            onClick={props.addCustom}
            disabled={props.showCustomField}
          >
            <AIcon type="plus" />Add Custom
          </Button>

          <Content>
            <BusinessLines {...props} />
          </Content>
        </StepCard>
      </div>
    </StepContainer>
    <WorkStatus swipedRight />
  </CardHolder>
)
const BusinessLinesForm = reduxForm({
  form: "BusinessLines",
  onSubmit: (data, dispatch, ownProps) => {
    dispatch(save(data)).then(() => {
      dispatch(push("step-three"))
      AnalyticsHelper.trackEvent(CloudEvent.OnboardingStep2)
    })
  }
})(BusinessLinesStep)

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemoteSubmit: () => dispatch(submit("BusinessLines")),
    submitCustomLine: () => dispatch({ type: "SUBMIT_CUSTOM_LINE" }),
    onCustomChange: e =>
      dispatch({ type: "CUSTOM_LINE_CHANGE", value: e.target.value }),
    addCustom: () => dispatch(addCustom()),
    toggle: name => dispatch(toggle(name))
  }
}

const onDemandTypes = [
  "Instacart",
  "Shipt",
  "Uber",
  "Lyft",
  "Doordash",
  "Airbnb",
  "Postmates",
  "Taskrabbit",
  "Favor",
  "Wonolo"
]

const getAvailableLines = businessLines =>
  !businessLines.persona.includes("Self-Employed")
    ? businessLines.available.filter(line => !onDemandTypes.includes(line))
    : businessLines.available

export default connect(
  ({ account: { businessLines } }) => ({
    ...businessLines,
    available: getAvailableLines(businessLines),
    initialValues: businessLines,
    enableReinitialize: true
  }),
  mapDispatchToProps
)(BusinessLinesForm)



// WEBPACK FOOTER //
// ./src/user/StepTwo.js